var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/Favorites.tsx
import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { useQueryClient as useQueryClient2 } from "@tanstack/react-query";
import avMessages2 from "@availity/message-core";

// src/lib/utils.ts
import avMessages from "@availity/message-core";
import { avSettingsApi } from "@availity/api-axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// src/lib/constants.tsx
var MAX_FAVORITES = 60;
var NAV_APP_ID = "Gateway-AvNavigation";
var AV_INTERNAL_GLOBALS = {
  FAVORITES_UPDATE: "av:favorites:update",
  FAVORITES_CHANGED: "av:favorites:changed",
  MAX_FAVORITES: "av:favorites:maxed",
  MY_TOP_APPS_UPDATED: "av:topApps:updated"
};

// src/lib/utils.ts
var isFavorite = (arg) => Boolean(typeof (arg == null ? void 0 : arg.id) === "string" && typeof (arg == null ? void 0 : arg.pos) === "number");
var validateFavorites = (unvalidatedFavorites) => {
  const validatedFavorites = Array.isArray(unvalidatedFavorites) ? unvalidatedFavorites == null ? void 0 : unvalidatedFavorites.filter(isFavorite) : [];
  return validatedFavorites;
};
var submit = (_0, _1) => __async(void 0, [_0, _1], function* ({ favorites, targetFavoriteId }, applicationId) {
  const response = yield avSettingsApi.setApplication(applicationId, { favorites });
  return { favorites: response.data.favorites, targetFavoriteId };
});
var getFavorites = (applicationId) => __async(void 0, null, function* () {
  var _a, _b, _c;
  const result = yield avSettingsApi.getApplication(applicationId);
  const unvalidatedFavorites = (_c = (_b = (_a = result == null ? void 0 : result.data) == null ? void 0 : _a.settings) == null ? void 0 : _b[0]) == null ? void 0 : _c.favorites;
  const validatedFavorites = validateFavorites(unvalidatedFavorites);
  return validatedFavorites;
});
var useFavoritesQuery = (enabled, applicationId) => useQuery(["favorites"], () => getFavorites(applicationId), { enabled });
var useSubmitFavorites = ({ onMutationStart }, applicationId) => {
  const queryClient = useQueryClient();
  const _a = useMutation(({ favorites, targetFavoriteId }) => submit({ favorites, targetFavoriteId }, applicationId), {
    onMutate(variables) {
      onMutationStart == null ? void 0 : onMutationStart(variables.targetFavoriteId);
    },
    onSuccess(data) {
      queryClient.setQueryData(["favorites"], data.favorites);
    }
  }), { mutateAsync: submitFavorites } = _a, rest = __objRest(_a, ["mutateAsync"]);
  return __spreadValues({ submitFavorites }, rest);
};
var sendUpdateMessage = (favorites, applicationId) => {
  if (applicationId === NAV_APP_ID) {
    avMessages.send({ favorites, event: AV_INTERNAL_GLOBALS.FAVORITES_UPDATE });
  }
};
var openMaxModal = (applicationId) => {
  if (applicationId === NAV_APP_ID) {
    return avMessages.send(AV_INTERNAL_GLOBALS.MAX_FAVORITES);
  }
  return null;
};

// src/lib/Favorites.tsx
import { jsx } from "react/jsx-runtime";
var FavoritesContext = createContext(null);
var FavoritesProvider = ({
  children,
  onFavoritesChange,
  onMaxFavoritesReached,
  settingsFavorites,
  settingsStatus,
  applicationId = NAV_APP_ID,
  maxFavorites = MAX_FAVORITES
}) => {
  const [lastClickedFavoriteId, setLastClickedFavoriteId] = useState("");
  const queryClient = useQueryClient2();
  const { data: favoritesData, status: favoritesDataStatus } = useFavoritesQuery(!settingsStatus, applicationId);
  const favorites = settingsStatus ? settingsFavorites : favoritesData;
  const queryStatus = settingsStatus ? settingsStatus : favoritesDataStatus;
  const { submitFavorites, status: mutationStatus } = useSubmitFavorites({
    onMutationStart(targetFavoriteId) {
      setLastClickedFavoriteId(targetFavoriteId);
    }
  }, applicationId);
  useEffect(() => {
    const subscribe = () => {
      if (applicationId === NAV_APP_ID) {
        const unsubscribeFavoritesChanged = avMessages2.subscribe(
          AV_INTERNAL_GLOBALS.FAVORITES_CHANGED,
          (data) => {
            if (data == null ? void 0 : data.favorites) {
              queryClient.setQueryData(["favorites"], data == null ? void 0 : data.favorites);
            }
          },
          { ignoreSameWindow: false }
        );
        const unsubscribeFavoritesUpdate = avMessages2.subscribe(
          AV_INTERNAL_GLOBALS.FAVORITES_UPDATE,
          (data) => {
            if (data == null ? void 0 : data.favorites) {
              queryClient.setQueryData(["favorites"], data == null ? void 0 : data.favorites);
            }
          },
          { ignoreSameWindow: false }
        );
        return () => {
          unsubscribeFavoritesChanged();
          unsubscribeFavoritesUpdate();
        };
      }
    };
    const unsubscribe = subscribe();
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [queryClient, applicationId]);
  const deleteFavorite = (id) => __async(void 0, null, function* () {
    if (favorites) {
      const response = yield submitFavorites({
        favorites: favorites.filter((favorite) => favorite.id !== id),
        targetFavoriteId: id
      });
      sendUpdateMessage(response.favorites, applicationId);
      onFavoritesChange == null ? void 0 : onFavoritesChange(response.favorites);
    }
  });
  const addFavorite = (id) => __async(void 0, null, function* () {
    if (!favorites) return false;
    if (favorites.length >= maxFavorites) {
      openMaxModal(applicationId);
      if (onMaxFavoritesReached && typeof onMaxFavoritesReached === "function") {
        yield onMaxFavoritesReached(favorites);
      }
      return false;
    }
    const maxFavorite = favorites.reduce((accum, fave) => {
      if (!accum || fave.pos > accum.pos) {
        accum = fave;
      }
      return accum;
    }, null);
    const newFavPos = maxFavorite ? maxFavorite.pos + 1 : 0;
    const response = yield submitFavorites({
      favorites: [...favorites, { id, pos: newFavPos }],
      targetFavoriteId: id
    });
    sendUpdateMessage(response.favorites, applicationId);
    onFavoritesChange == null ? void 0 : onFavoritesChange(response.favorites);
    const isFavorited = response.favorites.find((f) => f.id === id);
    return !!isFavorited;
  });
  return /* @__PURE__ */ jsx(
    FavoritesContext.Provider,
    {
      value: {
        favorites,
        queryStatus,
        mutationStatus,
        lastClickedFavoriteId,
        deleteFavorite,
        addFavorite
      },
      children
    }
  );
};
var noOp = () => {
};
var useFavorites = (id) => {
  const context = useContext(FavoritesContext);
  if (context === null) {
    throw new Error("useFavorites must be used within a FavoritesProvider");
  }
  const { favorites, queryStatus, mutationStatus, lastClickedFavoriteId, deleteFavorite, addFavorite } = context;
  const isLastClickedFavorite = lastClickedFavoriteId === id;
  const isFavorited = useMemo(() => {
    const fav = favorites == null ? void 0 : favorites.find((f) => f.id === id);
    return !!fav;
  }, [favorites, id]);
  const toggleFavorite = () => isFavorited ? deleteFavorite(id) : addFavorite(id);
  const isDisabled = queryStatus === "loading" || queryStatus === "idle" || mutationStatus === "loading";
  let status = "initLoading";
  if (queryStatus === "loading") status = "initLoading";
  if (queryStatus === "reloading") status = "reloading";
  if (mutationStatus === "loading") status = "reloading";
  if (queryStatus === "error" || mutationStatus === "error") status = "error";
  if (queryStatus === "success" && (mutationStatus === "success" || mutationStatus === "idle")) status = "success";
  return {
    isFavorited,
    status,
    isLastClickedFavorite,
    toggleFavorite: isDisabled ? noOp : toggleFavorite
  };
};

// src/lib/FavoriteHeart.tsx
import { Tooltip } from "@availity/mui-tooltip";
import { HeartIcon, HeartEmptyIcon } from "@availity/mui-icon";
import { CircularProgress } from "@availity/mui-progress";
import { styled } from "@mui/material/styles";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var icons = {
  spinner: /* @__PURE__ */ jsx2(CircularProgress, { "aria-hidden": true, size: "small", loadingCaption: false }),
  unknownDisabledHeart: /* @__PURE__ */ jsx2(HeartIcon, { "aria-hidden": true, color: "disabled" }),
  favoritedDisabledHeart: /* @__PURE__ */ jsx2(HeartIcon, { "aria-hidden": true, color: "error", opacity: "0.6" }),
  unfavoritedDisabledHeart: /* @__PURE__ */ jsx2(HeartEmptyIcon, { "aria-hidden": true, color: "disabled", opacity: "0.6" }),
  favoritedHeart: /* @__PURE__ */ jsx2(HeartIcon, { "aria-hidden": true, color: "error" }),
  unfavoritedHeart: /* @__PURE__ */ jsx2(HeartEmptyIcon, { "aria-hidden": true, color: "secondary" })
};
var DEFAULT_SIZE = "2.5rem";
var FavoriteHeartContainer = styled("div", {
  name: "AvFavoriteHeart",
  slot: "Root"
})(({ customSize }) => ({
  height: customSize,
  width: customSize
}));
var FavoriteInput = styled("input", {
  name: "AvFavoriteHeart",
  slot: "input"
})(({ customSize }) => ({
  height: customSize,
  width: customSize,
  minHeight: customSize,
  minWidth: customSize
}));
var fontSize = (size = DEFAULT_SIZE) => {
  const match = size.match(/^(\d*\.?\d+)(px|rem)$/);
  if (!match) {
    throw new Error("Invalid size format. Must be in 'px' or 'rem'.");
  }
  const [, number, unit] = match;
  const halvedNumber = parseFloat(number) / 2;
  return `${halvedNumber}${unit}`;
};
var FavoriteIcon = styled("div", {
  name: "AvFavoriteHeart",
  slot: "icon"
})(({ customSize }) => ({
  fontSize: fontSize(customSize)
}));
var validateSize = (size) => {
  const match = size.match(/^(\d*\.?\d+)(px|rem)$/);
  if (!match) {
    return false;
  }
  const [, number, unit] = match;
  const value = parseFloat(number);
  if (unit === "rem" && value >= 1.5) {
    return true;
  } else if (unit === "px" && value >= 24) {
    return true;
  }
  return false;
};
var FavoriteHeart = ({
  id,
  name,
  onChange,
  onMouseDown,
  disabled = false,
  customSize = DEFAULT_SIZE
}) => {
  const { isFavorited, isLastClickedFavorite, status, toggleFavorite } = useFavorites(id);
  const handleChange = (event) => {
    onChange == null ? void 0 : onChange(isFavorited, event);
    toggleFavorite();
  };
  const handleKeyPress = (event) => {
    if (event.code === "Enter" || event.key === "Enter") {
      onChange == null ? void 0 : onChange(isFavorited, event);
      toggleFavorite();
    }
  };
  const iconKey = (() => {
    if (status === "initLoading") return "unknownDisabledHeart";
    if (status === "reloading") {
      if (isLastClickedFavorite) return "spinner";
      return isFavorited ? "favoritedDisabledHeart" : "unfavoritedDisabledHeart";
    }
    if (disabled) {
      return isFavorited ? "favoritedDisabledHeart" : "unfavoritedDisabledHeart";
    }
    if (isFavorited) return "favoritedHeart";
    return "unfavoritedHeart";
  })();
  const cursor = disabled || !isLastClickedFavorite && (status === "initLoading" || status === "reloading") ? "not-allowed" : void 0;
  const tooltipContent = `${isFavorited ? "Remove from" : "Add to"} My Favorites`;
  const favoriteInputProps = {
    onKeyDown: handleKeyPress,
    type: "checkbox",
    "aria-label": `Favorite ${name}`,
    id: `av-favorite-heart-${id}`,
    disabled,
    checked: isFavorited,
    onChange: handleChange,
    onMouseDown,
    style: { cursor }
  };
  const validSize = validateSize(customSize) ? customSize : DEFAULT_SIZE;
  return /* @__PURE__ */ jsxs(FavoriteHeartContainer, { customSize: validSize, children: [
    /* @__PURE__ */ jsx2(FavoriteIcon, { customSize: validSize, children: icons[iconKey] }),
    /* @__PURE__ */ jsx2(
      "span",
      {
        style: {
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0,0,0,0)",
          whiteSpace: "nowrap",
          border: 0
        },
        "aria-live": isLastClickedFavorite && (status === "reloading" || status === "error") ? "polite" : "off",
        children: isLastClickedFavorite && status === "reloading" ? "Loading..." : isLastClickedFavorite && status === "error" ? "An error has occurred. Please try again." : ""
      }
    ),
    disabled ? /* @__PURE__ */ jsx2(FavoriteInput, __spreadValues({ customSize: validSize }, favoriteInputProps)) : /* @__PURE__ */ jsx2(Tooltip, { title: tooltipContent, placement: "top", children: /* @__PURE__ */ jsx2(FavoriteInput, __spreadValues({ customSize: validSize }, favoriteInputProps)) })
  ] });
};
export {
  FavoriteHeart,
  FavoritesProvider,
  useFavorites
};
